<template>
    <div>
        <div v-if="loading || blocked" class="loading-text">
            <h1 v-if="loading">Proszę czekać ładuję jadłospis ...</h1>
            <h1 v-if="blocked && !loading">{{ 'app.menu_already_opened_start' | trans }}<a href="" @click.prevent="takeOver">{{ 'app.here' | trans }}</a>{{ 'app.menu_already_opened_end' | trans }}</h1>
        </div>
        <div v-else>
          <other-menus-modal ref="otherMenusModal"></other-menus-modal>
          <menu-manage-modal
              :patient-id="patientIntegerId"
              :add-button-enabled="false"
              :action="openEditModal ? 'go_to_list' : 'reload'"
              ref="menuManageModal"
              v-if="isMenuMode"
          />
            <section class="content-header">
                <div class="row">
                    <div class="col-md-12 text-right">
                        <v-app id="vuetify-app" class="no--wrap">
                            <v-container fluid pa-0>
                                <v-layout>
                                    <v-flex xs5>
                                        <v-layout align-center justify-space-between row text-center>
                                            <v-flex v-if="isMenuMode">
                                                <span class="text-bold center-block">{{'app.patient' | trans}}</span>
                                                {{menu.patient.fullName()}}
                                            </v-flex>
                                            <v-flex v-if="!isMenuMode">
                                                <span class="text-bold center-block">{{'app.name' | trans}}</span>
                                                {{ configuration.title }}
                                            </v-flex>
                                            <v-flex>
                                                <span class="text-bold center-block">{{'app.period' | trans}}</span>
                                                {{period}}
                                            </v-flex>
                                            <v-flex>
                                                <span class="text-bold center-block">{{'app.kcal' | trans}}</span>
                                                {{menu.schema.desiredEnergy.amount}}
                                                kcal
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs7>
                                        <div style="padding-right: 20px">

                                            <icon-button
                                                    icon="arrow_back"
                                                    color="#3c8dbc"
                                                    @click="back"
                                            >
                                                {{ 'app.back' | trans}}
                                            </icon-button>
                                            <icon-button
                                                v-if="hasPermission('menu_schema_mobile_app_send') && isMenuMode && configuration.sentToMobileApp "
                                            icon="send_to_mobile"
                                            color="success"
                                            @click="updateInMobileApp"
                                            >
                                              {{
                                                trans('app.mobile_app.update_menu', {'date': formatSentToMobileAppAt(sentToMobileAppAt)})
                                              }}
                                            </icon-button>
                                            <icon-button
                                                    v-if="isMenuMode"
                                                    icon="edit"
                                                    color="#3c8dbc"
                                                    permission="menu_schema_edit"
                                                    @click="openMenuEditModal"
                                            >
                                                {{ 'app.edit' | trans}}
                                            </icon-button>

                                            <template v-if="!isMenuMode && hasPermission('schema_edit')">
                                                <schema-form :model-id="menu.id" @stored="schemaUpdated">
                                                    <template #button="{ activator: dialog }">

                                                        <v-tooltip bottom attach>
                                                            <template #activator="{ on: tooltip }">
                                                                <v-btn
                                                                        v-on="{ ...tooltip, ...dialog }"
                                                                        flat
                                                                        icon
                                                                        color="#3c8dbc">
                                                                    <v-icon>edit</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>{{ 'app.edit' | trans}}</span>
                                                        </v-tooltip>
                                                    </template>

                                                </schema-form>
                                            </template>

                                            <icon-button
                                                    v-if="hasPermission('creator_comments_edit')"
                                                    @click="toggleAllComments()"
                                                    icon="comment"
                                                    ref="allComments"
                                                    color="blue"
                                            >
                                                {{this.commentsHidden ? trans('app.show_comments') : trans('app.hide_comments')}}
                                            </icon-button>

                                            <icon-button
                                                v-if="hasPermission('creator_products_search')"
                                                @click="searchProducts()"
                                                icon="search"
                                                color="#00acc1"
                                            >
                                              {{ 'app.search_products' | trans}}
                                            </icon-button>

                                            <manage-meals-dialog :id="menu.id"></manage-meals-dialog>

                                            <icon-button
                                                    @click="showModal({ component: 'summary-form', options: {large: true} })"
                                                    icon="assignment"
                                                    color="green darken-1"
                                                    :permission="SYSTEM_SCHEMA || hasPermission('menu_schema_summary')"
                                            >
                                                {{ 'app.summary' | trans}}
                                            </icon-button>

                                            <template v-if="isMenuMode">
                                                <icon-button
                                                        @click="showModal({ component: 'print', options: {large:true} })"
                                                        icon="local_printshop"
                                                        color="green darken-1"
                                                        permission="menu_schema_print"
                                                >
                                                    {{ 'app.export_as_pdf' | trans}}
                                                </icon-button>
                                            </template>

                                            <template v-if="isMenuMode">
                                                <export-menu-form :id="menu.id"></export-menu-form>
                                            </template>

                                            <icon-button
                                                    @click="showModal({ component: 'shopping-list', data: {}, options: {large:true} })"
                                                    icon="shopping_cart"
                                                    color="indigo"
                                                    :permission="SYSTEM_SCHEMA || hasPermission('creator_shopping_list')"
                                            >
                                                {{ 'app.products_list' | trans}}
                                            </icon-button>
                                        </div>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs12>
                                        <v-layout v-if="!isMenuMode">
                                            <div v-show="configuration.schemaTags.filter(t => t.type === 'diet').length > 0">
                                                <v-label>Dieta</v-label>
                                                <v-chip label small outline color="success" :key="tag.name"
                                                        v-for="tag in configuration.schemaTags.filter(t => t.type === 'diet').map(t => t.name)">
                                                    {{tag}}
                                                </v-chip>
                                            </div>
                                            <div v-show="configuration.schemaTags.filter(t => t.type === 'schema').length > 0">
                                                <v-label>Tagi</v-label>
                                                <v-chip label small outline color="success" :key="tag.name"
                                                        v-for="tag in configuration.schemaTags.filter(t => t.type === 'schema').map(t => t.name)">
                                                    {{tag}}
                                                </v-chip>
                                            </div>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-app>
                    </div>
                </div>
            </section>

            <div class="container-fluid creator__wrapper">
                <div class="row">
                    <div v-if="MENU_READ_ONLY" :value="MENU_READ_ONLY"
                         class="alert alert-warning">
                        <span v-html="readOnlyNotice()"></span>
                    </div>
                    <v-alert type="success" :value="productsReplaced" :dismissible="true" @input="closeProductsReplacedAlert()">
                      Zamieniono produkty. Sprawdź opis przygotowania.
                      <i class="fa fa-question-circle"
                         v-tooltip="`Sprawdź, czy w opisie przygotowania dania nie są użyte produkty, które zostały zamienione.`"></i>
                    </v-alert>
                    <v-alert v-if="searchedProduct" type="success" :value="searchedProductFound" :dismissible="true" @input="closeSearchProductAlert()">
                      Produkt: "{{ searchedProduct.name }}" został odnaleziony w jadłospisie.
                    </v-alert>
                    <v-alert v-if="searchedProduct" type="warning" :value="searchedProductNotFound" :dismissible="true" @input="closeSearchProductAlert()">
                      Produkt: "{{ searchedProduct.name }}" nie został odnaleziony w jadłospisie.
                    </v-alert>
                    <div :class="{hidden: this.commentsHidden}" class="all__comments">
                        <button v-if="!menu.schema.hasComment()"
                                @click="getMenuCommentAddClickListener()"
                                class="btn btn-success mb-20"
                                ref="addMenuComment">
                            Dodaj komentarz do jadłospisu
                        </button>
                        <button v-if="menu.schema.hasComments()" @click="removeAllComments()" class="btn btn-danger mb-20">
                            Usuń wszystkie komentarze
                        </button>
                    </div>
                    <div :class="{hidden: menuCommentHidden }" class="menu__comment">
                        <span class="text-bold center-block"
                              :class="{hidden: menuCommentInputHidden}"
                        >{{'app.menu_comment' | trans}}:</span>
                        <span @click="getMenuCommentRemoveClickListener()"
                              :class="{hidden: !menu.schema.hasComment()}"
                              class="menu__comment_remove"
                              role="button"
                              title="Usuń komentarz">
                            <i class="fa fa-times text-red"></i>
                        </span>
                        <p class="menu__comment_input"
                           contenteditable="true"
                           title="Kliknij by edytować"
                           ref="menuComment"
                           :class="{hidden: menuCommentInputHidden}"
                           placeholder="Komentarz do jadłospisu..."
                           v-comment-input-click-outside="{
                            exclude: ['menuComment', 'addMenuComment', 'allComments'],
                            handler: 'getMenuCommentOnOutsideClickListener',
                            }"
                           @blur="getMenuCommentOnBlurListener($event)"
                           v-html="menu.schema.comment"
                        >
                        </p>
                    </div>
                    <div class="menu__window" v-dragscroll:ignore="'item'" :style="menuWindowStyle">
                      <div class="menu__container">
                        <day v-for="(day, index) in days" :is-first="index===0" :id="day.id" :key="day.id" :isAssignedToUser="MENU_MODE"
                             :showNutrientsDetails="showNutrientsDetails" ref="days">
                          <template slot="actions" v-if="hasPermission('schema_edit')">
                            <li role="presentation"
                                v-if="menu.getNumberOfDays() < maxMenuDaysLength && hasPermission('schema_edit')">
                              <a @click="copyDay(day)"><i class="fa fa-copy"></i>Kopiuj</a>
                            </li>
                            <li role="presentation">
                                <a class="disabled" v-if="!hasPermission('creator_copy_to_another_menu')"
                                      v-tooltip="trans('app.no_access_tooltip')"
                                ><i class="fa fa-copy"></i>{{ 'app.menu.copy_to_another_menu' | trans }}</a>
                                <a v-else @click="copyDayToAnotherMenu(day)"><i class="fa fa-copy"></i>{{ 'app.menu.copy_to_another_menu' | trans }}</a>
                            </li>
                            <li role="presentation" v-if="hasDayInClipboard">
                              <a @click="pasteDayFromAnotherMenu(day)"><i class="fa fa-paste"></i>{{ 'app.menu.paste_from_another_menu' | trans }}</a>
                            </li>
                            <li role="presentation"
                                v-if="menu.getNumberOfDays() > 1 && hasPermission('schema_edit')">
                              <a @click="deleteDay(day.id)"><i class="fa fa-times"></i>Usuń</a>
                            </li>
                          </template>
                        </day>
                      </div>
                      <div class="mt-2 mb-2">
                        <button @click="showNutrientsDetails = !showNutrientsDetails" class="btn btn-success">
                          <span>{{ trans(!showNutrientsDetails ? 'app.show_all_nutrients' : 'app.hide_all_nutrients') }}</span>
                        </button>
                      </div>
                    </div>
                    <modal></modal>
                </div>
            </div>
        </div>
    </div>
</template>


<style lang="scss" type="text/scss">
    @import "~vuejs-dialog/dist/vuejs-dialog.min.css";

    .content-header {
        margin: -15px -15px 15px -15px;
    }

    .menu__window {
      overflow: scroll;
    }

    .menu__window::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    .menu__window::-webkit-scrollbar-track {
      background-color: #e4e4e4;
      border-radius: 10px;
    }

    .menu__window::-webkit-scrollbar-thumb {
      background-color: #646464FF;
      border-radius: 10px;
    }

    .menu__window::-webkit-scrollbar-corner {
      background-color: transparent;
    }


    .menu__container {
      display: flex;
      flex-flow: row;

        > * {
            flex: 0 0 auto;
            display: flex;
            flex-direction: column;
        }
    }

    .vue-tooltip {
        display: block !important;
        z-index: 10000;

        .vue-tooltip-inner {
            background: black;
            color: white;
            border-radius: 3px;
            padding: 5px 10px 4px;
            font-size: 12px;
        }

        .vue-tooltip-arrow {
            width: 0;
            height: 0;
            border-style: solid;
            position: absolute;
            margin: 5px;
            border-color: black;
            z-index: 1;
        }

        &[x-placement^="top"] {
            margin-bottom: 5px;

            .vue-tooltip-arrow {
                border-width: 5px 5px 0 5px;
                border-left-color: transparent !important;
                border-right-color: transparent !important;
                border-bottom-color: transparent !important;
                bottom: -5px;
                left: calc(50% - 5px);
                margin-top: 0;
                margin-bottom: 0;
            }
        }

        &[x-placement^="bottom"] {
            margin-top: 5px;

            .vue-tooltip-arrow {
                border-width: 0 5px 5px 5px;
                border-left-color: transparent !important;
                border-right-color: transparent !important;
                border-top-color: transparent !important;
                top: -5px;
                left: calc(50% - 5px);
                margin-top: 0;
                margin-bottom: 0;
            }
        }

        &[x-placement^="right"] {
            margin-left: 5px;

            .vue-tooltip-arrow {
                border-width: 5px 5px 5px 0;
                border-left-color: transparent !important;
                border-top-color: transparent !important;
                border-bottom-color: transparent !important;
                left: -5px;
                top: calc(50% - 5px);
                margin-left: 0;
                margin-right: 0;
            }
        }

        &[x-placement^="left"] {
            margin-right: 5px;

            .vue-tooltip-arrow {
                border-width: 5px 0 5px 5px;
                border-top-color: transparent !important;
                border-right-color: transparent !important;
                border-bottom-color: transparent !important;
                right: -5px;
                top: calc(50% - 5px);
                margin-left: 0;
                margin-right: 0;
            }
        }

        &[aria-hidden='true'] {
            visibility: hidden;
            opacity: 0;
            transition: opacity .15s, visibility .15s;
        }

        &[aria-hidden='false'] {
            visibility: visible;
            opacity: 1;
            transition: opacity .15s;
        }

        &.info {
            $color: rgba(#004499, .9);

            .vue-tooltip-inner {
                background: $color;
                color: white;
                padding: 24px;
                border-radius: 5px;
                box-shadow: 0 5px 30px rgba(black, .1);
            }

            .tooltip-arrow {
                border-color: $color;
            }
        }

        &.vue-popover {
            $color: #fff;

            .vue-popover-inner {
                .popover-body {
                    padding: 15px;
                }

                .popover-footer {
                    padding: 15px;
                    text-align: right;
                    border-top: 1px solid #e5e5e5;
                }

                .popover-header {
                    padding: 15px;
                    border-bottom: 1px solid #e5e5e5;
                }

                background: $color;
                color: black;
                padding: 0;
                border-radius: 4px;
                box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
                border: 1px solid rgba(0, 0, 0, .15);
            }

            .popover-arrow {
                border-color: $color;
            }
        }
    }

    .loading-text {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
    }

    .menu__comment {
        position: relative;
    }

    .menu__comment_remove {
        position: absolute;
        top: 0;
        right: 0;
    }

    .menu__comment_input:focus {
        background: #fff;
    }

    .menu__comment_input:hover:not(:focus) {
        cursor: pointer;
    }

    .menu__comment_input:hover {
        cursor: auto;
    }

    .menu__comment_input:empty:before {
        content: attr(placeholder);
        pointer-events: none;
        display: block;
    }

    .toasted-container {
        align-items: flex-end;
    }
</style>

<script>
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import {
      addDay,
      dateFormatter,
      FORMAT_DATE, FORMAT_DATETIME,
      FORMAT_TIMESTAMP, SYSTEM_DATE
    } from '../utils/dateFormatter';
    import debounce from 'lodash/debounce';
    import {multiPortionFoodsManager} from "../services/MultiPortionFoodsManager";
    import {store} from "../store/store";
    import {invalidFoodExists} from "../services/invalidFoodChecker";
    import {round} from "../utils/money";
    import Vue from "vue";
    import {ClipboardService} from "../services/clipboard/ClipboardService";
    import {pasteDayFromClipboard} from "../services/CopyMenuDay";
    import {trans} from "../app";
    import MenuService from "../services/MenuService";

    export default {
        props: {
          'menu-routes': Object,
          menuIntegerId: {
            type: Number,
            required: false
          },
          patientIntegerId: {
            type: Number,
            required: false
          },
          openEditModal: {
            type: Boolean,
            default: false,
            required: false
          }
        },
        data() {
            return {
                showNutrientsDetails: false,
                loading: true,
                blocked: false,
                autoSavesCount: 0,
                menuCommentHidden: true,
                menuCommentInputHidden: true,
                productsReplaced: false,
                searchedProductFound: false,
                searchedProductNotFound: false,
                searchedProduct: null,
                savingConfigured: false,
                unloaded: false,
                menuWindowHeight: null,
            };
        },
        created() {
            this.setupResize();
            this.fetchConfiguration(this.menuRoutes.configuration).then(async () => {
              this.debounceSave = debounce(this.save, 1000 * 5);
              await this.load();
              if (this.isMenuMode) {
                this.fetchSentToMobileAppAt(this.configuration.sent_to_mobile_app_at).catch((error) => {
                  if (error.response && error.response.status === 409) {
                    this.blocked = true;
                  } else {
                    this.$toasted.global.error({message: 'Wystąpił błąd'});
                    this.sentryCaptureException(error);
                  }
                });
              }

              this.handleProductsReplacedEvent = ((replacedIn) => {
                if (replacedIn === 'menu' || replacedIn === 'plans') {
                  this.productsReplaced = true;
                }
              });
              this.$root.$on('products-replaced', this.handleProductsReplacedEvent);

              this.$root.$on('search-product-selected', (product) => {
                this.findProductsInMenu(product);
              });

              this.$root.$on('menu_edit_conflict', () => {
                this.blocked = true;
                this.setCurrentEditedMenu(null);
              });

              if (this.openEditModal) {
                this.openMenuEditModal();
              }
            }).catch((error) => {
              this.sentryCaptureException(error);
              this.$toasted.global.error({message: 'Wystąpił błąd'});
            });
            this.setupDragAndCopy();
        },
        mounted() {
          this.setMenuWindowHeight();
          this.setupClipboard();
        },
        beforeDestroy() {
          this.$root.$off('products-replaced', this.handleProductsReplacedEvent);
          this.$root.$off('menu_edit_conflict');
        },
        computed: {
              ...mapGetters([
                  'configuration',
                  'hasPermission',
                  'MENU_READ_ONLY',
                  'MENU_MODE',
                  'SYSTEM_SCHEMA',
                  'commentsHidden',
                  'foodsWithSearchedProduct',
                  'productsSameAsSearchedProduct',
                  'maxMenuDaysLength',
                  'sentToMobileAppAt',
              ]),
              ...mapState({
                  menu(state) {
                      return state.menu;
                  },
                  days(state) {
                      if (state.menu.schema) {
                          return state.menu.schema.days.sort((a, b) => a.date > b.date);
                      }
                      return [];
                  },
                  menuComment(state) {
                      if (state.menu.schema) {
                          return state.menu.schema.comment;
                      }
                  }
              }),
              period() {
                  let period = dateFormatter(this.menu.startDate, FORMAT_DATE);

                  if (this.days.length > 1)
                      period += ' - ' + dateFormatter(this.menu.endDate, FORMAT_DATE);

                  period += ' (' + this.menu.getNumberOfDays() + ' dni)';

                  if (!this.isMenuMode) {
                      period = this.menu.getNumberOfDays() + ' dni';
                  }
                  return period;
              },
              isMenuMode() {
                  return this.configuration.mode === 'menu';
              },
              menuWindowStyle() {
                return `height: ${this.menuWindowHeight}px;`
              },
              hasDayInClipboard() {
                if (ClipboardService.hasDay() === false) {
                  return false;
                }
                const day = ClipboardService.getDay();
                return day.metadata.menuId !== this.menu.id;
              }
          },
        methods: {
            ...mapActions([
              'storeMenu',
              'fetchMenu',
              'fetchConfiguration',
              'setCurrentEditedMenu',
              'syncStateWithStore',
              'fetchSentToMobileAppAt',
            ]),
            ...mapMutations([
              'addDay',
              'removeDay',
              'showModal',
              'checkDayRepetition',
              'toggleComments',
              'setProductsReplaced',
              'resetFoodsWithSearchedProduct',
              'resetProductsSameAsSearchedProduct',
              'updateFoodsWithSearchedProduct',
              'updateProductsSameAsSearchedProduct',
              'toggleDragAndCopy',
            ]),
            async back() {
                await this.save();
                window.location = this.menuRoutes.back;
            },
            async updateInMobileApp() {
              await this.save();
              (new MenuService()).updateInMobileApp(
                  this.menu.patient.externalId,
                  this.menuIntegerId,
              ).then(() => {
                this.fetchSentToMobileAppAt(this.configuration.sent_to_mobile_app_at).then(() => {
                  this.$toasted.global.info({message: trans('app.mobile_app.updated_menu')});
                }).catch((error) => {
                  if (error.response && error.response.status === 409) {
                    this.blocked = true;
                  } else {
                    this.$toasted.global.error({message: 'Wystąpił błąd'});
                    this.sentryCaptureException(error);
                  }
                })
              }).catch((error) => {
                if (error.response && error.response.status === 409) {
                  this.$refs.otherMenusModal.open(this.menu.startDate, this.menu.endDate, error.response.data.data);
                  return;
                }
                this.sentryCaptureException(error);
                this.$toasted.global.error({message: 'Wystąpił błąd'});
              });
            },
            async save() {
                if (this.blocked) {
                    return;
                }
                if (this.MENU_READ_ONLY) {
                    return;
                }

                if (this.isMenuMode && this.$refs.menuManageModal && this.$refs.menuManageModal.isOpen()) {
                  return;
                }

                if (invalidFoodExists(store.state.menu.schema)) {
                    this.$toasted.global.error({message: 'Jadłospis nie został zapisany! Sprawdź poprawność zaznaczonych dań'});
                    return;
                }

                await this.saveMenu();
            },
            async saveMenu() {
              try {
                await this.storeMenu(this.configuration.store);
                this.$toasted.global.success({message: 'Jadłospis został zapisany!'});
                this.$root.$emit('menuSaved');
                this.setProductsReplaced(false);
              } catch (error) {
                if (error.response && error.response.status === 409) {
                  this.blocked = true;
                } else if (error.response && error.response.status === 404) {
                      window.location.href = '/patients/' + this.menu.patient.externalId + '/menu';
                    } else {
                  this.$toasted.global.error({message: 'Jadłospis nie został zapisany!'});
                  this.sentryCaptureException(error);
                }
              }
            },
            async load() {
              this.loading = true;
              await this.fetchMenu(this.configuration.data_endpoint)
                  .catch((error) => {
                    this.sentryCaptureException(error);
                    if (error.response && error.response.status === 409) {
                      this.blocked = true;
                    } else {
                      this.$toasted.global.error({message: 'Wystąpił błąd'});
                    }
                  })
                  .then(() => {
                    this.loading = false;

                    if (!this.savingConfigured) {
                      this.configureAutoSaving();
                    }
                  });
            },
            takeOver() {
              this.loading = true;
              this.fetchConfiguration(this.menuRoutes.configuration).then(() => {
                axios.post(this.configuration.take_over).then(async () => {
                  await this.load();
                  this.blocked = false;
                  if (this.openEditModal) {
                    setTimeout(() => this.openMenuEditModal(), 400);
                  }
                });
              }).catch((error) => {
                this.sentryCaptureException(error);
                this.$toasted.global.error({message: 'Wystąpił błąd'});
              });
            },
            copyDay(day) {
                const lastDay = this.menu.schema.getLastDay();
                const copiedDay = multiPortionFoodsManager.copyDay(
                    day,
                    Number(addDay(lastDay.date, 1).format(FORMAT_TIMESTAMP)),
                    this.menu.schema
                );
                this.addDay(copiedDay);
                this.checkDayRepetition(copiedDay);
                this.$nextTick(() => {
                    this.setDaysWidth();
                });
            },
            copyDayToAnotherMenu(day) {
              for (const i in day.plans) {
                  for (const y in day.plans[i].foods) {
                      if (day.plans[i].foods[y].isMultiPortionFood()) {
                          this.$toasted.global.info({message: trans('app.menu.copy_multi_portion_food_warning')});
                          break;
                      }
                  }
              }

              ClipboardService.addDay(day, {menuId: this.menu.id});
              this.$toasted.global.info({message: trans('app.menu.day_copied')});
            },
            pasteDayFromAnotherMenu(currentDay) {
              pasteDayFromClipboard(currentDay);
              this.checkDayRepetition(currentDay);
            },
            schemaUpdated() {
                window.location.reload(true);
            },
            hideMenuComment() {
                this.menuCommentHidden = true;
            },
            showMenuComment() {
                this.menuCommentHidden = false
            },
            hideMenuCommentInput() {
                this.menuCommentInputHidden = true;
            },
            showMenuCommentInput() {
                this.menuCommentInputHidden = false;
            },
            showAllComments() {
                this.showMenuComment();
                this.toggleComments(false);
                this.$root.$emit('toggle_all_comments', this.commentsHidden);
            },
            hideAllComments() {
                this.hideMenuComment();
                this.toggleComments(true);
                this.$root.$emit('toggle_all_comments', this.commentsHidden);
            },
            getMenuCommentAddClickListener() {
                this.showMenuCommentInput();
                this.$nextTick(() => {
                    this.$refs.menuComment.focus();
                });
            },
            getMenuCommentRemoveClickListener() {
                if (this.menu.schema.hasComment()) {
                    this.$dialog.confirm('Czy na pewno chcesz usunąć ten komentarz?').then(()=> {
                        this.menu.schema.comment = '';
                        this.hideMenuCommentInput();
                    }).catch(()=>{});
                }
            },
            getMenuCommentOnBlurListener($event) {
                this.menu.schema.comment = this.$sanitize($event.target.innerText).replace(/\n/g, '<br>');
            },
            getMenuCommentOnOutsideClickListener() {
                if (!this.menu.schema.hasComment()) {
                    this.hideMenuCommentInput();
                }
            },
            toggleAllComments() {
                if (this.commentsHidden) {
                    this.showAllComments();
                    if (this.menu.schema.hasComment()) {
                        this.showMenuCommentInput();
                    }
                } else {
                    this.hideAllComments();
                }
            },
            removeAllComments() {
                this.$dialog.confirm('Czy na pewno chcesz usunąć wszystkie komentarze?').then(()=> {
                    this.menu.schema.comment = '';
                    this.hideMenuCommentInput();
                    this.$root.$emit('remove_all_comments');
                }).catch(()=>{});
            },
            closeProductsReplacedAlert() {
              this.productsReplaced = false;
            },
            searchProducts() {
              this.resetFoodsWithSearchedProduct();
              this.resetProductsSameAsSearchedProduct();
              this.showModal({
                component: 'search-product-modal'
              });
            },
            findProductsInMenu(product) {
              this.searchedProductFound = false;
              this.searchedProductNotFound = false;
              this.searchedProduct = product;

              this.resetFoodsWithSearchedProduct();
              this.resetProductsSameAsSearchedProduct();

              this.days.forEach(day => {
                day.plans.forEach(plan => {
                  plan.products.forEach(planProduct => {
                    if (planProduct.externalId === product.externalId) {
                      this.updateProductsSameAsSearchedProduct(planProduct);
                    }
                  });
                  plan.foods.forEach(planFood => {
                    planFood.products.forEach(foodProduct => {
                      if (foodProduct.externalId === product.externalId) {
                        this.updateFoodsWithSearchedProduct(planFood);
                      }
                    });
                  });
                })
              })

              if (this.foodsWithSearchedProduct.length > 0 || this.productsSameAsSearchedProduct.length > 0) {
                this.searchedProductFound = true;
              } else {
                this.searchedProductNotFound = true;
              }
            },
            closeSearchProductAlert() {
              this.searchedProductFound = false;
              this.searchedProductNotFound = false;
              this.searchedProduct = null;

              this.resetFoodsWithSearchedProduct();
              this.resetProductsSameAsSearchedProduct();
            },
            prepareMenuForEditOrScale() {
              if (typeof this.menu.schema.prescribedNutrients === 'undefined') {
                return null;
              }
              const nutrients = {};
              for (const externalId in this.menu.schema.prescribedNutrients) {
                nutrients[externalId] = {
                  id: Number(externalId),
                  value: this.menu.schema.prescribedNutrients[externalId],
                }
              }
              return {
                id: this.menuIntegerId,
                start_date: dateFormatter(this.menu.startDate, SYSTEM_DATE),
                days: this.menu.schema.days.length,
                desired_diet_energy: this.menu.schema.desiredEnergy.amount,
                nutrients,
              };
            },
            openMenuEditModal() {
              this.setCurrentEditedMenu(this.prepareMenuForEditOrScale());
            },
            configureAutoSaving() {
              if (!this.MENU_READ_ONLY) {
                setInterval(this.debounceSave, 10 * 60 * 1000);
              }
              window.addEventListener('beforeunload', () => {
                if (!this.unloaded) {
                  this.unloaded = true;
                  if (!this.MENU_READ_ONLY) {
                    axios.post(this.menuRoutes.release).catch(() => {});
                  }
                  this.debounceSave();
                }
              });
              this.savingConfigured = true;
            },
            setMenuWindowHeight() {
              this.menuWindowHeight = round(window.innerHeight - 150,0);
            },
            deleteDay(dayId) {
              if (this.menu.getNumberOfDays() === 1) {
                Vue.toasted.global.error({message: 'Menu musi zawierać przynajmniej 1 dzień'});
                return;
              }
              Vue.dialog.confirm('Czy na pewno chcesz usunąć ten dzień?')
                  .then(() => {
                    this.removeDay(dayId);
                    this.$nextTick(() => {
                      this.setDaysWidth();
                    });
                  }).catch(() => {
              });
            },
            setDaysWidth() {
              this.$nextTick(() => {
                if (this.$refs.days === undefined) {
                  return;
                }
                this.$refs.days.forEach((dayComponent) => {
                  dayComponent.setDayWidth();
                });
              });
            },
            setupDragAndCopy() {
              const isMac = window.navigator.platform.indexOf('Mac') === 0;
              const dragAndCopyKeyCodes = isMac ? ['MetaLeft', 'MetaRight'] : ['ControlLeft','ControlRight'];
              document.onkeyup = (event) => {
                if (dragAndCopyKeyCodes.includes(event.code)) {
                  this.toggleDragAndCopy(false);
                }
              };
              document.onkeydown = (event) => {
                if (dragAndCopyKeyCodes.includes(event.code)) {
                  this.toggleDragAndCopy(true);
                }
              };
            },
            setupClipboard() {
                setInterval(() => {
                    this.syncStateWithStore();
                }, 1000);
            },
            setupResize() {
              window.addEventListener('resize', this.setMenuWindowHeight);
              window.addEventListener('resize', this.setDaysWidth);
            },
            readOnlyNotice() {
              let notice = trans('app.schema_read_only');
              if (this.days.length > 7 && !this.hasPermission('menu_schema_31_days')) {
                notice = notice + ' ' + trans('app.schema_31_days_notice');
              }
              if (!this.MENU_MODE && this.hasPermission('menu_schema_import')) {
                notice = notice + ' ' + trans('app.schema_import_notice');
              }
              return notice;
            },
            formatSentToMobileAppAt(date) {
              return dateFormatter(date, FORMAT_DATETIME);
            }
        },
        watch: {
            days: {
                deep: true,
                immediate: false,
                handler: function () {
                    this.autoSavesCount++;
                    // prevent saving on load
                    if (this.autoSavesCount > 2)
                        this.debounceSave();
                },
            },
            menuComment: {
                deep: true,
                immediate: false,
                handler: function () {
                    this.autoSavesCount++;
                    // prevent saving on load
                    if (this.autoSavesCount > 2)
                        this.debounceSave();
                },
            },
        },
    };
</script>
